export * from './public_api';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/node_modules/angularfire2/auth/index.js
// module id = ../../../../angularfire2/auth/index.js
// module chunks = vendor